import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import {PrizeTableUI} from './PrizeTableUI'


export class PrizeTable extends BaseTablePage {
  
  constructor (props) {
    super(props);
    this.getDataUrl = "api/v1/GetPrize?offset=";
    this.className = "Prize";
  }

  render () 
  {
    if (!this.state.isLoaded) {
      return <div className="box-body"> در حال بارگذاری</div>;
  }  
    return (
      <div className="container">
        <PrizeTableUI data={this.state.data}  onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/prize/PrizeTable.js